import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import StreamScreen from './StreamScreen'
import { State } from '../../../dataStore/reducers/reducerType'

const StreamScreenIndex = (props) => {

  const streamSource = useSelector((state: State) => state.syncUi.eventStreamUrl) as string
  const isBridgeInstance = useSelector((state: State) => state.config.bridgeName !== '') as boolean

  return <StreamScreen
    isMuted={props.isMuted}
    videoSourceUrl={streamSource}
    isBridgeInstance={isBridgeInstance}
  />

}

export default StreamScreenIndex